var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-loading"},[_c('div',{staticClass:"logo"},[_c('a',{style:(`background-image: url('/img/logo-conicle-red.png')`),attrs:{"id":"logo"}})]),_c('CncLoading',{attrs:{"size":"small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }